import React, {useEffect, useState} from 'react';

import classNames from 'classnames';
import {isEmpty} from 'lodash';
import {Button, Container, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {useParams} from 'react-router';

import ContentTable from 'components/Contents/ContentTable';
import {ContentPaginationState} from 'components/Contents';
import StatusBadge from 'components/Badges/StatusBadge';
import {SearchLoadMore} from 'components/Searches';
import {CB_ACCREDITATION_COLORS} from 'configs';
import {date} from 'utils/dates';

import useGetCBSectors from './useGetCBSectors';
import useGetCBStandardsSector from './useGetCBStandardsSector';

import styles from '../styles.module.scss';

const ScopeModal = (props) => {
  const {abId, cbId, sector, toggle} = props;
  const {sectors_code, sectors_name, sectors_id} = sector || {};

  const {isLoading, data, meta, reload} = useGetCBStandardsSector(
    cbId,
    abId,
    sectors_id
  );
  const {total_pages} = meta || {};

  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (!!sector) reload({offset: offset});
  }, [sector, offset]);

  return (
    <Modal centered isOpen={!!sector} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {sectors_code && sectors_code + ' — ' + sectors_name}
      </ModalHeader>
      <ModalBody style={{padding: '1.5rem 1.5rem 0.5rem 1.5rem'}}>
        <Container className={styles['table-container']}>
          <ContentTable
            v2
            meta={meta}
            hover={false}
            className="mb-0"
            minHeight="364px"
            responsive={false}
            isFetching={isLoading}
            head={[
              'Standards and Schemes',
              'Accreditation Status',
              {
                label: 'Date',
                value: 'suspended_withdrawn_date',
                tooltip:
                  'Technical Sectors effectivity date of suspension / withdrawal',
                onChangeSort: (order) => {
                  setOffset(0);
                  reload({
                    offset: 0,
                    order: order,
                    order_by: !!order ? 'suspended_withdrawn_date' : '',
                  });
                },
              },
              'Full/Limited',
              'Extent of Scope',
            ]}
          >
            {data.map((item, index) => {
              const {
                sectors_accreditation_status,
                standards_name,
                scheme_name,
                suspended_withdrawn_date,
                full_limited,
                scope_extent,
              } = item;

              return (
                <tr key={index}>
                  <td>{[standards_name, scheme_name].join(' : ')}</td>
                  <td>
                    <StatusBadge
                      pill
                      status={sectors_accreditation_status}
                      colors={CB_ACCREDITATION_COLORS}
                      className="text-white"
                    />
                  </td>
                  <td>{date(suspended_withdrawn_date)}</td>
                  <td>{full_limited}</td>
                  <td>{scope_extent}</td>
                </tr>
              );
            })}
          </ContentTable>
        </Container>
        <ContentPaginationState
          previousLabel="Previous"
          nextLabel="Next"
          offset={offset}
          totalPages={total_pages ? total_pages : 0}
          handleChangeOffset={(newOffset) => setOffset(newOffset)}
        />
      </ModalBody>
    </Modal>
  );
};

function CBAccreditationScopeTechnicalSectors(props) {
  const {selectedAB} = props;

  const {cbId} = useParams();

  const [sector, setSector] = useState('');

  const toggle = (item) => {
    const isOpen = !item.target;
    if (isOpen) setSector(item);
    else setSector('');
  };

  const {accreditation_bodies_id} = selectedAB || {};
  const {isLoading, data, meta, reload} = useGetCBSectors(
    cbId,
    accreditation_bodies_id
  );
  const {offset, total_pages, total_rows} = meta || {};

  return (
    <Container className="p-0" tag="section">
      <h3 className={classNames(styles['section__title'], 'mb-4')}>
        Technical Sectors {`(${total_rows || 0})`}
      </h3>

      <Container className={styles['table-container']}>
        <ContentTable
          v2
          meta={meta}
          hover={false}
          className="mb-0"
          minHeight="364px"
          responsive={false}
          isFetching={isEmpty(data) && isLoading}
          head={[
            // 'Sector Group',
            'Sector Code',
            'Sector Name',
            'View Full Accreditation Scope',
          ]}
          loadMore={
            !isEmpty(data) && (
              <SearchLoadMore
                className={'my-3'}
                isLoading={isLoading}
                loadMore={() => reload(parseInt(offset) + 1)}
                hasMore={parseInt(offset) + 1 < parseInt(total_pages)}
              />
            )
          }
        >
          {data.map((item, index) => {
            const {
              // sectors_group_name,
              sectors_code,
              sectors_name,
              standards_scheme_count,
            } = item;

            return (
              <tr key={index}>
                {/* <td>{sectors_group_name}</td> */}
                <td>{sectors_code}</td>
                <td>{sectors_name}</td>
                {parseInt(standards_scheme_count) > 0 && (
                  <td>
                    <Button
                      outline
                      color="primary"
                      className="rounded"
                      onClick={() => toggle(item)}
                      disabled={isLoading}
                    >
                      View
                    </Button>
                  </td>
                )}
              </tr>
            );
          })}
        </ContentTable>
      </Container>

      <ScopeModal
        abId={accreditation_bodies_id}
        cbId={cbId}
        sector={sector}
        toggle={toggle}
      />
    </Container>
  );
}

export default CBAccreditationScopeTechnicalSectors;
